import type { ExtractPropTypes } from 'vue'

import { buildProps, definePropType } from '@ll-plus/utils'

import type SelectGroup from './select-group.vue'

export interface ISelectGroupItem {
  name?: string
  value?: any
  [key: string]: any
}

export const selectGroupFormType = [
  'input',
  'select',
  'range-picker',
  'treeSelect'
] as const

export const selectGroupData = buildProps({
  // buildProps和defineprops一样
  /**
   * @description 表单提示占位符
   */
  placeholder: {
    type: String
  },
  /**
   * @description 表单的字段 name
   */
  name: {
    type: String,
    required: true
  },
  /**
   * @description 右边表单的 value
   */
  value: {
    type: String,
    required: true
  },
  /**
   * @description SVG 图标的大小，size x size
   */
  showFormType: {
    type: String,
    values: selectGroupFormType
  },
  /**
   * @description 格式化属性例如tree/select
   */
  fieldNames: {
    type: definePropType<object>(Object)
  },
  /**
   * @description select的options
   */
  options: {
    type: definePropType<any[]>(Array)
  },
  /**
   * @description 左侧选择的options
   */
  list: {
    type: definePropType<ISelectGroupItem[]>(Array)
  },
  /**
   * @description 是否在下拉框select最前面添加全部
   */
  noFirstAddAll: {
    type: Boolean
  }
} as const)
export const selectGroupProps = buildProps({
  /**
   * @description 选中select中的某一项（和value对应）
   */
  selectValue: {
    type: String
  },
  /**
   * @description 右边表单的 value
   */
  value: {
    type: [Array, String, Number, Boolean, Object],
    default: undefined
  },
  /**
   * @description select的options
   */
  data: {
    type: definePropType<SelectGroupData[]>(Array),
    default: () => []
  }
} as const)

export const selectGroupEmits = {
  change: (selectV: string, value?: any) => !!selectV || !!value,
  onSelectChange: (selectV: string, item: SelectGroupData) =>
    !!selectV && !!item // 左侧selectchange
}

export const LEFT_SELECT_MIN_WIDTH = 84 // 左侧select的宽度

// props
export type SelectGroupProps = ExtractPropTypes<typeof selectGroupProps>
export type SelectGroupData = ExtractPropTypes<typeof selectGroupData>
export type SelectGroupFormType = SelectGroupData['showFormType']

export type SelectGroupEmits = typeof selectGroupEmits

// instance
export type SelectGroupInstance = InstanceType<typeof SelectGroup>
